import React, { useState, useEffect } from "react";

import IconButton from "./IconButton";

const EditContainer = ({
  children,
  title,
  className,
  defaultOpen = false,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  return (
    <div className={className}>
      <div className="d-flex justify-content-between">
        <IconButton
          icon={open ? "ChevronDown" : "ChevronRight"}
          className="p-1"
          onClick={() => setOpen(!open)}
        >
          <div className="header-text ml-2">{title}</div>
        </IconButton>
      </div>
      {open && <div className="pt-2">{children}</div>}
    </div>
  );
};

export default EditContainer;
